import { Component } from '@angular/core';
import { FieldConfig } from 'models/field.interface';
import { FormGroup } from '@angular/forms';
import { UtilityService } from 'services';

@Component({
  templateUrl: './select-multiple.component.html'
})
export class SelectMultipleComponent {
  field: FieldConfig;
  group: FormGroup;
  constructor(private util: UtilityService) { }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
  getValidationMessage(val) {
    return 'Please Select atleast one Option.';
  }
}
